<template>
    <div class="w-full p-[16px]">
        <div class="mb-[12px]">
          <h2 class="text-[18px] text-[#2b2b2b] font-light">Prévision congé</h2>
        </div>
        <div class="bg-white rounded-lg mb-[8px]">
          <div class="flex items-center justify-between">
              <div class="flex items-center gap-x-[12px] text-[#2b2b2b] font-light">
                  <span v-bind:class="getActiveClass('Prévision congé')" v-on:click="selectBar('Prévision congé')">Prévision congé</span>
                  <span v-bind:class="getActiveClass('Congé')" v-on:click="selectBar('Congé')">Congé</span>
              </div>
          </div>
        </div>

        <div v-if="getActiveTab('Prévision congé')" class="w-full">
          <div class="bg-white rounded-lg text-black">
            <FullCalendar :options="calendarOptions" />
          </div>
        </div>
        <div v-if="getActiveTab('Congé')" class="w-full">
          <div class="bg-white rounded-lg text-black">
            <FullCalendar :options="calendarCongeOptions" />
          </div>
        </div>

        <div v-if="show" class="fixed flex items-center justify-center top-0 left-0 w-full h-screen overflow-hidden bg-[#000000a0] z-[999999999]">
          <div class="w-1/3 p-8 text-black rounded-lg bg-white relative">
            <X v-on:click="close" color="#000" class="absolute top-2 right-2 cursor-pointer"/>
            <div class="underline">Requête de {{ name }}</div>
            <div class="my-4 flex flex-col gap-y-1">
              <label for="comment" class="font-light">Commentaire</label>
              <textarea v-model="form" name="comment" id="comment" class="border rounded-lg p-4 w-full"></textarea>
            </div>
            <div class="flex justify-around">
              <button v-on:click="rejectPreview" :disabled="rejectStatus || validStatus" class="w-[49%] py-3 rounded-lg bg-red-600 text-white">Rejeter</button>
              <button v-on:click="validPreview" :disabled="rejectStatus || validStatus" class="w-[49%] py-3 rounded-lg bg-[#3C41E9] text-white">Valider</button>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import {X} from "lucide-vue-next";
import API from '@/service/API.js';
import toast from '@/components/ui/toast';
export default {
    name: 'MyPreview',
    components: {
        FullCalendar,X
    },
    data() {
        return {
            show:false,
            validStatus:false,
            rejectStatus:false,
            id:"",
            name:"",
            active:"Prévision congé",
            form:"",
            debut:null,
            fin:null,
            types:[],
            motifs:[],
            calendarOptions: {
              timeZone: 'UTC',
              plugins: [ dayGridPlugin, interactionPlugin ],
              initialView: 'dayGridMonth',
              eventColor: '#378006',
              events: [
              ],
              locale: 'fr',
              firstDay: 1,
              eventClick:this.validOrRejectPreview
            },
            calendarCongeOptions: {
              timeZone: 'UTC',
              plugins: [ dayGridPlugin, interactionPlugin ],
              initialView: 'dayGridMonth',
              eventColor: '#378006',
              events: [
              ],
              locale: 'fr',
              firstDay: 1,
            }
        };
    },
    mounted() {
        this.getAllPreview();
        this.getDemandeConge();
        this.getMotif();
    },
    methods: {
        getAllPreview(){
          API.get("previews").then((response) => {
            if(response.data.status){
              const tab = [];
              for(const event of response.data.data) {
                if(event.status == "Attente")tab.push({
                  title: "Congé -" + event.user.first_name + ' ' + event.user.last_name +" "+ this.isExpire(event.date_end),
                  start: event.date_start,
                  end: event.date_end,
                  color: this.generateRandomBeautifulHexColor(event.date_end), // Default color if not specified
                  extendedProps:{
                    id: event.id,
                    name: event.user.first_name + ' ' + event.user.last_name,
                    start: event.date_start,
                    end: event.date_end,
                  }
                });
              }
              this.calendarOptions.events = [...tab];
            }
            // this.calendarOptions.events = response.data;
          }).catch((error) => {
            console.error("Error fetching preview data:", error);
          });
        },
        getActiveClass(libelle){
            return `px-4 py-3 rounded-xl cursor-pointer ${libelle == this.active ? "bg-[#5357eb] text-white" : "bg-gray-100 text-black"}`;
        },
        selectBar(libelle){
            this.active = libelle;
        },
        getActiveTab(libelle){
            return this.active == libelle
        },
        generateRandomBeautifulHexColor(str){
          const date = new Date()
          const month = (date.getMonth() + 1).toString().padStart(2,0);
          if(Number(str.split("-")[1]) < Number(month)) return "#B5B5B5";
          const min = 50;
          const max = 200;
          const getRandomByte = () => {
            return Math.floor(Math.random() * (max - min + 1)) + min;
          };
          const r = getRandomByte();
          const g = getRandomByte();
          const b = getRandomByte();
          const toHex = (c) => c.toString(16).padStart(2, '0');
          return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
        },
        getDemandeConge(){
          //localStorage.getItem("userId")
          const date = new Date();
          const years = date.getFullYear();
          const month = (date.getMonth() + 1).toString().padStart(2,0);
          const day = date.getDate().toString().padStart(2,0);
          const formData = new FormData();
          formData.append("date",years+"-"+month+"-"+day)
          API.post("getMembersLeaves/"+localStorage.getItem("userId"),formData)
          .then((res)=>{
            if(res.data.status){
              const tab = [];
              for(const event of res.data.data) {
                tab.push({
                  title: "Congé -" + event.exception.user.first_name + ' ' + event.exception.user.last_name,
                  start: event.exception.date_start,
                  end: event.exception.date_end,
                  color: this.generateRandomBeautifulHexColor(event.exception.date_end), // Default color if not specified,
                  
                });
              }
              this.calendarCongeOptions.events = [...tab];
            }
          })
          .catch()
        },
        validOrRejectPreview(info){
          this.show = true;
          this.name = info.event.extendedProps.name;
          this.id = info.event.extendedProps.id;
          this.debut = info.event.extendedProps.start;
          this.fin = info.event.extendedProps.end;
        },
        close(){
          this.show = false;
        },
        isExpire(str){
          const date = new Date()
          const month = (date.getMonth() + 1).toString().padStart(2,0);
          return Number(str.split("-")[1]) < Number(month) ? "- Expiré" : "";
        },
        getMotif(){
            API.get("/getTypesAndMotifs")
            .then((data)=>{
                this.motifs = data.data["motifs"].filter((el)=> el["is_leave"] == 1);
                this.types = data.data["types"].filter((el)=> el["symbol"] == "a");
            })
            .catch(e=>{console.log(e)})
        },
        async validPreview(){
          this.validStatus = true;
          try {
            const response = await API.put("previews/"+this.id,{
              status:"Validé",
              comment: this.form
            });
            if(!response.data.status){
              toast.error("Erreur","Erreur survenue sur le serveur",3000);
              throw new Error("Erreur sur serveur");
            }
            const formData = new FormData();
            formData.append("type_id",this.types[0]["id"]);
            formData.append("motif_id",5);
            formData.append("date_start", this.debut);
            formData.append("date_end", this.fin);
            formData.append("hour",null);
            formData.append("other_motif","Validé par responsable");
            const response2 = await API.post("askForPermission",formData);
            if(response2.data["status"]){
              toast.success("Succes","Demande de congé enregistré, vous recevrez la réponse sur mon mail",7000)
            }
            this.getAllPreview();
            this.getDemandeConge()
          } catch (error) {
            console.log(error)
          }finally{
            this.validStatus = false;
            this.show = false;
          }
          
        },
        rejectPreview(){
          this.rejectStatus = true;
          API.put("previews/"+this.id,{
            status:"Rejeté",
            comment: this.form
          })
          .then((res)=>{
            if(res.data.status){
              toast.success("Succès","Preview rejeter",3000);
              this.getAllPreview();
              this.show = false;
            }
          })
          .catch()
          .finally(()=>{
            this.rejectStatus = false;
          })
        }
    }
};
</script>